import React, { useEffect, useState } from 'react';
import {BsPersonSquare} from "react-icons/bs"

const HomePageAdmin = () => {
    const [clientsNumber,setClientsNumber] = useState(0)
    const [pharmaciesNumber,setPharmaciesNumber] = useState(0)
    const [postesNumber,setPostesNumber] = useState(0)

    return (
        <div>
            <div className='row justify-content-center text-white '>
                <div className='col-3 bg-primary row py-2 m-3 justify-content-center shadow' style={{borderRadius:'10px'}}>
                    <BsPersonSquare style={{fontSize:'100px'}} />
                    <p className='text-center fs-4'>Clients {clientsNumber} </p>
                </div>
                <div className='col-3 bg-primary row py-2 m-3 justify-content-center shadow' style={{borderRadius:'10px'}}>
                    <BsPersonSquare style={{fontSize:'100px'}} />
                    <p className='text-center fs-4'>Pharmacies {pharmaciesNumber} </p>
                </div>
                <div className='col-3 bg-primary row py-2 m-3 justify-content-center shadow' style={{borderRadius:'10px'}}>
                    <BsPersonSquare style={{fontSize:'100px'}} />
                    <p className='text-center fs-4'>Postes de santé {postesNumber} </p>
                </div>
            </div>
            <div>
                {/* Calendrier */}
            </div>
        </div>
    );
};

export default HomePageAdmin;